



















import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';

export default {
  name: "SpaceCard",
  components: { AppPicture },
  props: {
    item: {
      type: Object,
      required: true
    },
    partnerId: {
      type: String,
      required: true
    }
  },
  computed: {
    image() {
      return this.item?.image?.little;
    },
    objectType() {
      return this.item?.object_type;
    },
    ovzAvailable() {
      return this.item?.is_ovz ? 'Да' : 'Нет';
    }
  },
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organizations/card/spaces/components/SpaceCard.vue